import React from 'react'

import { BorderedDiv, TBorderedDivProps } from './BorderedDiv'

export type TRoundDivProps = { size?: TBorderedDivProps['h'] } & TBorderedDivProps

export const RoundDiv: TFCC<TRoundDivProps> = ({ size, ...otherProps }) => (
  <BorderedDiv w={size} h={size} borderRadius="50%" {...otherProps} />
)
